import { createSlice } from '@reduxjs/toolkit';
import { WALLET_TYPE } from 'structure/user/WalletConnect/helper/wallet.const';
// Define a type for the slice state
interface WalletState {
  error: string | null;
  selectedWallet: WALLET_TYPE | undefined;
  showWalletConnectModal: boolean;
  showWalletManageModal: boolean;
}

// Define the initial state using that type
const initialState: WalletState = {
  error: null,
  selectedWallet: undefined,
  showWalletConnectModal: false,
  showWalletManageModal: false,
};

export const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    updateSelectedWallet: (state, { payload: { wallet } }) => {
      state.selectedWallet = wallet;
    },
    clearWallet: (state) => {
      Object.assign(state, initialState);
    },
    showWalletConnectModal: (state, action: { payload: boolean }) => {
      state.showWalletConnectModal = action.payload;
    },
    showWalletManageModal: (state, action: { payload: boolean }) => {
      state.showWalletManageModal = action.payload;
    },
  },
});

export const {
  clearWallet,
  updateSelectedWallet,
  showWalletConnectModal,
  showWalletManageModal,
} = walletSlice.actions;

export const walletReducer = walletSlice.reducer;
